import { useEffect, useState } from "react";

/** What a failed or stalled load says while the browser is offline. */
export const OFFLINE_RETRY_TEXT =
  "You're offline. This retries when you're back online.";

/** Whether the browser thinks it's online, kept current. */
export const useOnline = () => {
  const [online, setOnline] = useState(
    () => typeof navigator === "undefined" || navigator.onLine !== false
  );
  useEffect(() => {
    const update = () => setOnline(navigator.onLine !== false);
    window.addEventListener("online", update);
    window.addEventListener("offline", update);
    return () => {
      window.removeEventListener("online", update);
      window.removeEventListener("offline", update);
    };
  }, []);
  return online;
};
